export const getBalanceUser = state => state.balance.balance;
export const getExpenseUser = state => state.balance;
export const loadingOnBalance = state => state.balance.isLoading;
